var getUrl = function getUrl(galleryName, imageNumber) {
  var isHashInUrl = window.location.hash;
  var location = window.location.href;
  var galleryUrl;

  if (isHashInUrl) {
    galleryUrl = "".concat(window.location.origin + window.location.pathname, "#galleryName=").concat(galleryName, ",imageNumber=").concat(imageNumber);
  } else {
    galleryUrl = "".concat(location, "#galleryName=").concat(galleryName, ",imageNumber=").concat(imageNumber);
  }

  return galleryUrl;
};

export { getUrl };
//# sourceMappingURL=get_url.js.map
